import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/assets/img/icon/check-circle.svg'
import _imports_1 from '@/assets/img/icon/copy.svg'
import _imports_2 from '@/assets/img/icon/edit.svg'
import _imports_3 from '@/assets/img/icon/delete.svg'
import _imports_4 from '@/assets/img/icon/clockPlus.svg'
import _imports_5 from '@/assets/img/icon/detail.svg'
import _imports_6 from '@/assets/img/icon/to.svg'
import _imports_7 from '@/assets/img/icon/infoRed.svg'
import _imports_8 from '@/assets/img/icon/refundRed.svg'
import _imports_9 from '@/assets/img/icon/invoiceRed.svg'
import _imports_10 from '@/assets/img/icon/payKlaimGreen.svg'
import _imports_11 from '@/assets/img/icon/return-box.svg'
import _imports_12 from '@/assets/img/icon/return-people.svg'
import _imports_13 from '@/assets/img/icon/wallet-blue-grey.svg'
import _imports_14 from '@/assets/img/icon/payment-disable-grey.svg'
import _imports_15 from '@/assets/img/icon/calendar-grey.svg'
import _imports_16 from '@/assets/img/icon/statistic-up-blue-grey.svg'
import _imports_17 from '@/assets/img/icon/park-outline-average-blue-grey.svg'
import _imports_18 from '@/assets/img/icon/x-square-grey.svg'
import _imports_19 from '@/assets/img/icon/refresh-black.png'
import _imports_20 from '@/assets/img/icon/withdrawal-grey.svg'
import _imports_21 from '@/assets/img/icon/edit-box-grey.svg'
import _imports_22 from '@/assets/img/icon/levelup-grey.svg'


const _hoisted_1 = { class: "px-4 py-4 mr-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "mr-3 w-4",
    alt: "verif"
  }),
  /*#__PURE__*/_createVNode("span", null, "Verifikasi Akun")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "mr-3 w-4",
    alt: "copy"
  }),
  /*#__PURE__*/_createVNode("span", null, "Duplikat")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "mr-3 w-4",
    alt: "add"
  }),
  /*#__PURE__*/_createVNode("span", null, "Tambah")
], -1)
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "mr-3 w-4",
  alt: "edit"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "mr-3 w-4",
    alt: "clone"
  }),
  /*#__PURE__*/_createVNode("span", null, "Clone")
], -1)
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "mr-3 w-4",
  alt: "del"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_4,
    class: "mr-3 w-5",
    alt: "addHour"
  }),
  /*#__PURE__*/_createVNode("span", null, "Tambahkan Jam")
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_5,
    class: "mr-3 w-4",
    alt: "detail"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Detail")
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_6,
    class: "mr-3 w-4",
    alt: "toManifest"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Ke Manifest Jadwal")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_7,
    class: "mr-3 w-4",
    alt: "pending"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-red-darken-3" }, "Pending")
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_8,
    class: "mr-3 w-4",
    alt: "refund"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-red" }, "Refund")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_9,
    class: "mr-3 w-4 h-4",
    alt: "add klaim"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-red" }, "Tambah Klaim Agen")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_10,
    class: "mr-3 w-4",
    alt: "pay klaim"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-green" }, "Pembayaran Klaim")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_11,
    class: "mr-3 w-4",
    alt: "package return"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Pengembalian Paket")
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_12,
    class: "mr-3 w-4",
    alt: "change courier"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Ganti Kurir")
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_12,
    class: "mr-3 w-4",
    alt: "assign courier"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Assign Kurir")
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_13,
    class: "mr-3 w-4",
    alt: "activate top"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Aktifkan TOP")
], -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_14,
    class: "mr-3 w-4",
    alt: "activate top"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Non Aktifkan TOP")
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_13,
    class: "mr-3 w-4",
    alt: "activate top"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Ubah Deposit TOP")
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_15,
    class: "mr-3 w-4",
    alt: "change cutoff date"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Ubah Jatuh Tempo")
], -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_16,
    class: "mr-3 w-4",
    alt: "change discount level"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Ubah Level Diskon")
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_17,
    class: "mr-3 w-4",
    alt: "change transaction limits"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Ubah Limit Transaksi")
], -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_18,
    class: "mr-3 w-4",
    alt: "manual cut off"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Cut Off TOP")
], -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_19,
    class: "mr-3 w-4",
    alt: "resetKurir"
  }),
  /*#__PURE__*/_createVNode("span", { class: "" }, "Atur Ulang Perangkat")
], -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_20,
    class: "mr-3 w-4",
    alt: "withdrawDeposit"
  }),
  /*#__PURE__*/_createVNode("span", { class: "color-blue-grey-darken-1" }, "Penarikan Deposit")
], -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_21,
    class: "mr-3 w-4",
    alt: "edit"
  }),
  /*#__PURE__*/_createVNode("span", null, "Edit Pelanggan")
], -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_22,
    class: "mr-3 w-4",
    alt: "edit"
  }),
  /*#__PURE__*/_createVNode("span", null, "Naik Level Pelanggan")
], -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    class: "mr-3 w-4",
    alt: "edit"
  }),
  /*#__PURE__*/_createVNode("span", null, "Edit Permission")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", null, [
      (_ctx.verif)
        ? (_openBlock(), _createBlock("li", {
            key: 0,
            class: "cursor-pointer py-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('verif')))
          }, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      (_ctx.copy)
        ? (_openBlock(), _createBlock("li", {
            key: 1,
            class: "cursor-pointer py-1",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('copy')))
          }, [
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      (_ctx.add)
        ? (_openBlock(), _createBlock("li", {
            key: 2,
            class: "cursor-pointer py-1",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('add')))
          }, [
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      (_ctx.edit)
        ? (_openBlock(), _createBlock("li", {
            key: 3,
            class: "cursor-pointer py-1",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('edit')))
          }, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("span", null, _toDisplayString(_ctx.editTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.clone)
        ? (_openBlock(), _createBlock("li", {
            key: 4,
            class: "cursor-pointer py-1",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('clone')))
          }, [
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (_ctx.del)
        ? (_openBlock(), _createBlock("li", {
            key: 5,
            class: "cursor-pointer py-1",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('del')))
          }, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("span", null, _toDisplayString(_ctx.delTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.addHour)
        ? (_openBlock(), _createBlock("li", {
            key: 6,
            class: "cursor-pointer py-1",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('addHour')))
          }, [
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      (_ctx.detail)
        ? (_openBlock(), _createBlock("li", {
            key: 7,
            class: "cursor-pointer py-1",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('detail')))
          }, [
            _hoisted_11
          ]))
        : _createCommentVNode("", true),
      (_ctx.toManifest)
        ? (_openBlock(), _createBlock("li", {
            key: 8,
            class: "cursor-pointer py-1",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('toManifest')))
          }, [
            _hoisted_12
          ]))
        : _createCommentVNode("", true),
      (_ctx.pending)
        ? (_openBlock(), _createBlock("li", {
            key: 9,
            class: "cursor-pointer py-1",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('pending')))
          }, [
            _hoisted_13
          ]))
        : _createCommentVNode("", true),
      (_ctx.refund)
        ? (_openBlock(), _createBlock("li", {
            key: 10,
            class: "cursor-pointer py-1",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('refund')))
          }, [
            _hoisted_14
          ]))
        : _createCommentVNode("", true),
      (_ctx.addKlaim)
        ? (_openBlock(), _createBlock("li", {
            key: 11,
            class: "cursor-pointer py-1",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('addKlaim')))
          }, [
            _hoisted_15
          ]))
        : _createCommentVNode("", true),
      (_ctx.payKlaim)
        ? (_openBlock(), _createBlock("li", {
            key: 12,
            class: "cursor-pointer py-1",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('payKlaim')))
          }, [
            _hoisted_16
          ]))
        : _createCommentVNode("", true),
      (_ctx.packageReturn)
        ? (_openBlock(), _createBlock("li", {
            key: 13,
            class: "cursor-pointer py-1",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('packageReturn')))
          }, [
            _hoisted_17
          ]))
        : _createCommentVNode("", true),
      (_ctx.changeCourier)
        ? (_openBlock(), _createBlock("li", {
            key: 14,
            class: "cursor-pointer py-1",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('changeCourier', $event)))
          }, [
            _hoisted_18
          ]))
        : _createCommentVNode("", true),
      (_ctx.assignCourier)
        ? (_openBlock(), _createBlock("li", {
            key: 15,
            class: "cursor-pointer py-1",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('assignCourier', $event)))
          }, [
            _hoisted_19
          ]))
        : _createCommentVNode("", true),
      (_ctx.activateTop)
        ? (_openBlock(), _createBlock("li", {
            key: 16,
            class: "cursor-pointer py-1",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('activateTop', $event)))
          }, [
            _hoisted_20
          ]))
        : _createCommentVNode("", true),
      (_ctx.nonActivateTop)
        ? (_openBlock(), _createBlock("li", {
            key: 17,
            class: "cursor-pointer py-1",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('nonActivateTop', $event)))
          }, [
            _hoisted_21
          ]))
        : _createCommentVNode("", true),
      (_ctx.changeDeposit)
        ? (_openBlock(), _createBlock("li", {
            key: 18,
            class: "cursor-pointer py-1",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('changeDeposit', $event)))
          }, [
            _hoisted_22
          ]))
        : _createCommentVNode("", true),
      (_ctx.changeCutoffDate)
        ? (_openBlock(), _createBlock("li", {
            key: 19,
            class: "cursor-pointer py-1",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('changeCutoffDate', $event)))
          }, [
            _hoisted_23
          ]))
        : _createCommentVNode("", true),
      (_ctx.discountLevel)
        ? (_openBlock(), _createBlock("li", {
            key: 20,
            class: "cursor-pointer py-1",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('discountLevel', $event)))
          }, [
            _hoisted_24
          ]))
        : _createCommentVNode("", true),
      (_ctx.transLimit)
        ? (_openBlock(), _createBlock("li", {
            key: 21,
            class: "cursor-pointer py-1",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('transLimit', $event)))
          }, [
            _hoisted_25
          ]))
        : _createCommentVNode("", true),
      (_ctx.manualCutOff)
        ? (_openBlock(), _createBlock("li", {
            key: 22,
            class: "cursor-pointer py-1",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$emit('manualCutOff', $event)))
          }, [
            _hoisted_26
          ]))
        : _createCommentVNode("", true),
      (_ctx.resetKurir)
        ? (_openBlock(), _createBlock("li", {
            key: 23,
            class: "cursor-pointer py-1",
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.$emit('resetKurir', $event)))
          }, [
            _hoisted_27
          ]))
        : _createCommentVNode("", true),
      (_ctx.withdrawDeposit)
        ? (_openBlock(), _createBlock("li", {
            key: 24,
            class: "cursor-pointer py-1",
            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.$emit('withdrawDeposit', $event)))
          }, [
            _hoisted_28
          ]))
        : _createCommentVNode("", true),
      (_ctx.editPelanggan)
        ? (_openBlock(), _createBlock("li", {
            key: 25,
            class: "cursor-pointer py-1",
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$emit('editPelanggan')))
          }, [
            _hoisted_29
          ]))
        : _createCommentVNode("", true),
      (_ctx.levelupPelanggan)
        ? (_openBlock(), _createBlock("li", {
            key: 26,
            class: "cursor-pointer py-1",
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.$emit('levelupPelanggan')))
          }, [
            _hoisted_30
          ]))
        : _createCommentVNode("", true),
      (_ctx.editPermission)
        ? (_openBlock(), _createBlock("li", {
            key: 27,
            class: "cursor-pointer py-1",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.$emit('editPermission')))
          }, [
            _hoisted_31
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}